import { Drawer, message } from "antd";
import React, { useState } from "react";
import { useBankAccountReportHook } from "../banks/hooks";
import { CircleAnimationCompact } from "../loading";
import { CashFlowTable } from "../banks/components";
import { PdfReportReview } from "./PdfReportReview";
import { generate_bank_account_report } from "../../services";

import PropTypes from "prop-types";
import { BankConsolidatedReportTemplate } from "../banks/banks_templates/BankConsolidatedReportTemplate";
import { sumBasePoints } from "../banks/components/utilsCashFlowTable";

export const BankAccountsAllReport = ({ 
	token, 
	company, 
	bankAccountReportSelected, 
	setBankAccountReportSelected = () => {},
}) => {
	const [data, setData] = useState([]);
	const [bankAccountsInvolved, setBankAccountsInvolved] = useState([]);

	const onSetData = ({data: dataFromRes = [], bankAccounts = [], message: messageFromRes = ""}) => {
		if(dataFromRes.length === 0){
			message.info(messageFromRes === "" ? "No se encontraron transacciones para crear el reporte." : messageFromRes);
		}
		
		setData(dataFromRes);
		setBankAccountsInvolved(bankAccounts);
	};
	
	const {	
		dataToProcess,
		loading,
		openReviewInvoice,
		exchangeRate,
		isUSDActive,		
		currentYear,
		ExchangeComponent,
		DownloadOptions,
		setDataToProcess,
		setOpenReviewInvoice,
		onClose,
	} = useBankAccountReportHook({
		token, 
		company, 
		bankAccountReportSelected, 
		setBankAccountReportSelected,
		searchType: "consolidated_report",		
		onSendData: onSetData,
	});

	const finalBasePointsToSet = sumBasePoints(bankAccountsInvolved, isUSDActive, exchangeRate);	
	
	return (
		<Drawer
			title={"Reporte Consolidado de Transacciones Bancarias"}
			placement="right"
			onClose={onClose}
			open={bankAccountReportSelected !== null}
			width={"100%"}
			extra={DownloadOptions}
		>
			{loading && <CircleAnimationCompact />}
			
			{!loading && <CashFlowTable
				data={data} 
				currency={isUSDActive ? "$" : "Q"}
				originalCurrency={"GTQ"}
				exchangeRate={exchangeRate}
				isUSDActive={isUSDActive}				
				basePoints={finalBasePointsToSet}
				bankAccounts={bankAccountsInvolved}
				currentYear={currentYear}
				basePointsAllreadyConverted={true}
				onDataToSend={setDataToProcess}
				header={ExchangeComponent}
			/> }

			{open && 
				<PdfReportReview
					open={openReviewInvoice}
					content={dataToProcess}					
					renderContent={(dataMatrix) => <BankConsolidatedReportTemplate 
						dataMatrix={dataMatrix} 
						company={company} 
						bankAccountsInvolved={bankAccountsInvolved}
						isUSDActive={isUSDActive}
						exchangeRate={exchangeRate}
						year={`${currentYear}`}
					/>}
					onSetOpen={setOpenReviewInvoice}
					onConfirmAction={() => generate_bank_account_report(
						dataToProcess,
						company, 						
						"ALL",
						isUSDActive ? "USD" : "GTQ",
						(dataMatrix) => <BankConsolidatedReportTemplate 
							dataMatrix={dataMatrix} 
							company={company} 
							bankAccountsInvolved={bankAccountsInvolved}
							isUSDActive={isUSDActive}
							exchangeRate={exchangeRate}
							year={`${currentYear}`}
						/>
					)}
					title={"Prevista del Reporte Consolidado antes de descargar"}
					confirmText={"Descargar"}
				/>
			}
		</Drawer>
	);
};

BankAccountsAllReport.propTypes = {
	token: PropTypes.string.isRequired,
	company: PropTypes.shape({
		id: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
		tid: PropTypes.string.isRequired,
	}).isRequired,
	bankAccountReportSelected: PropTypes.object.isRequired, 
	setBankAccountReportSelected: PropTypes.func.isRequired,
};